// Utils
import cn from '../../../../utils/cn';

// Components
import Picto from '../../../atoms/Picto/Picto';

// Styles
import directEditCommon from '../DirectEditCommon.module.css';
import styles from './DirectEditValueSlot.module.css';

/** @typedef {'link'} DirectEditValueSlotAction */

/**
 * @param {DirectEditValueSlotAction | null | undefined} action
 * @returns {import('../../../atoms/Picto/Picto').AvailableIconName | null}
 */
function getActionIconName(action) {
  if (action === 'link') return 'arrow-up-right-md';
  return null;
}

/**
 * Cell value slot with optional action hint icon (inside the clickable control).
 * @param {object} props
 * @param {React.ReactNode} props.children
 * @param {DirectEditValueSlotAction | null | undefined} [props.action]
 * @returns {JSX.Element}
 */
function DirectEditValueSlot({ children, action }) {
  const iconName = getActionIconName(action);

  return (
    <span
      className={cn([
        styles.slot,
        directEditCommon['direct-edit-value-slot'],
      ])}
    >
      {children}
      {iconName ? (
        <Picto
          icon={iconName}
          className={styles['action-icon']}
          aria-hidden
        />
      ) : null}
    </span>
  );
}

export default DirectEditValueSlot;
